<script setup>
import BaseSidebar from "@/Components/UI/BaseSidebar.vue";
import {reactive, ref} from "vue";
import DocumentNeededAction from "@/Components/notifications/DocumentNeededAction.vue";
import LoadingSpinner from "@/Components/UI/loading/LoadingSpinner.vue";
import DocumentAction from "@/Components/notifications/DocumentAction.vue";
import EmployeeInvitationCompleted from "@/Components/notifications/EmployeeInvitationCompleted.vue";
import KnowledgeNotification from "@/Components/notifications/KnowledgeNotification.vue";
import BaseButton from "@/Components/UI/buttons/BaseButton.vue";

const open = ref(false);
const notifications = reactive({
    list: []
});
const next = ref(null);
const emit = defineEmits(['show', 'close']);

const parse = async (url) => {
    let parsed = (await axios.get(url)).data;
    if (!parsed?.data) {
        spinner.value.remove();
        return;
    }
    notifications.list = JSON.parse(JSON.stringify([...notifications.list, ...parsed.data]));
    next.value = parsed.links.next;
    if (!next.value) {
        spinner.value.remove();
    }
}

const show = async () => {
    emit('show');
    open.value = true;
    if (notifications.list.length) return;
    await parse(route('notifications.index'));
}

defineExpose({show});
const spinner = ref(null);
const loading = ref(false);

const scroll = async () => {
    if (spinner.value.getBoundingClientRect().top < window.innerHeight) {
        if (loading.value || !next.value) return;
        loading.value = true;
        await parse(next.value);
        loading.value = false;
    }
}
const close = () => {
    emit('close');
    open.value = false
}

const markAllRead = async () => {
    try {
        await axios.post(route('notifications.mark_all_read'));

        notifications.list.forEach(notification => {
            if (!notification.read_at) {
                notification.read_at = new Date().toISOString();
            }
        });
    } catch (error) {
        console.error('Ошибка при отметке уведомлений как прочитанных:', error);
    }
}
</script>

<template>
    <BaseSidebar :open="open"
                 @close="close"
                 @scroll="scroll">
        <template #title>Уведомления</template>
        <template #content>
            <div v-for="notification in notifications.list"
                 :key="notification.id"
                 class="pt-5 pr-10 relative">
                <DocumentNeededAction v-if="notification.type === 'document-needed-action' || notification.type === 'external-document-needed-action'"
                                      :notification="notification"/>
                <DocumentAction v-else-if="notification.type === 'document-action' || notification.type === 'external-document-action'"
                                :notification="notification"/>
                <EmployeeInvitationCompleted v-else-if="notification.type === 'employee-invitation-completed'"
                                             :notification="notification"/>
                <KnowledgeNotification v-else-if="notification.type?.startsWith('kb-')"
                                       :notification="notification"/>
                <div v-if="!notification.read_at"
                     class="absolute top-10 right-0 h-4 w-4 bg-accent-blue rounded-full"></div>
            </div>
            <div ref="spinner">
                <LoadingSpinner class="mx-auto my-10"
                                :width="30"/>
            </div>
        </template>
        <template #footer>
            <div class="w-full px-5 pb-4">
                <BaseButton
                    variant="neutral"
                    @click="markAllRead"
                    class="w-full justify-center text-dark-light bg-light-3 text-sm font-semibold leading-tight"
                >
                    Отметить всё прочитанными
                </BaseButton>
            </div>
        </template>
    </BaseSidebar>
</template>
